//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//styles
import './ResultsTable.less'


class ResultsTable extends Component {
    static propTypes = {
        children: PropTypes.object,
        titles: PropTypes.array,
    };

    static defaultProps = {
        children: '',
        titles: []
    };

    render() {
        const {children, titles} = this.props;

        if (!children.size) return null;

        const Trs = children.map((data, index) => {
            const meta = data.get('meta');

            const caseTitle = meta.get('case_title');
            const caseUuid = meta.get('case_uuid');
            const courtCode = meta.get('court_code');
            const caseNo = meta.get('case_no');
            const chapter = meta.get('chapter');
            const dateFiled = meta.get('date_filed');
            const dateClosed = meta.get('date_closed');
            const disposition = meta.get('disposition');

            const url = `${caseUuid}-${caseNo}-${caseTitle}`.replace(/[:\s]/ig, '-').toLowerCase();

            return (
                <tr className={index % 2 == 0 ? 'odd' : 'even'} key={index}>
                    <td>{caseTitle}</td>
                    <td>{courtCode}</td>
                    <td className="ir-search-no-wrap"><a href={`/filings/${url}`}>{caseNo}</a></td>
                    <td>{chapter}</td>
                    <td>{dateFiled}</td>
                    <td>{dateClosed}</td>
                    <td>{disposition}</td>
                </tr>
            );
        });

        return (
            <table className="results-table">
                <thead>
                <tr>{titles.map((title, index) => <th key={index}>{title}</th>)}</tr>
                </thead>
                <tbody>{Trs}</tbody>
            </table>

        );
    }

}

export default ResultsTable



/** WEBPACK FOOTER **
 ** ./src/components/Modules/ResultsTable/ResultsTable.js
 **/